export default __webpack_public_path__ + "static/media/c6.88c5d3c4.jpg";